<template>
  <div>
    <Drawer
      :title="changeModalTitle"
      v-model="changeModal"
      width="500"
      @on-close="formReset"
      :mask-closable="true">
      <Form :model="changeForm" ref="changeForm" @submit.native.prevent :rules="changeRule" :label-width="90" label-position="right">
        <FormItem prop="name" label="安全组名称">
          <Input v-model="changeForm.name" placeholder="填写安全组名称" :maxlength="128" />
        </FormItem>
        <FormItem label="描述">
          <Input v-model="changeForm.description" placeholder="（选填）" type="textarea" :rows="4" :maxlength="256" />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
          <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
    <Card shadow>
      <Row>
        <div style="float: right;">
          <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getSecurityGroupData(securityGroup.page)">刷新</Button>
          <Button
            @click="formReset(); changeModal = true; changeModalTitle = '创建安全组';"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">创建安全组</Button>
        </div>
      </Row>
      <Table
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="securityGroup.data"
        :columns="securityGroup.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ securityGroup.data.length }} 条记录，总共 {{ securityGroup.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="securityGroup.count"
            :current="securityGroup.page"
            :page-size="securityGroup.size"
            @on-change="getSecurityGroupData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudSecurityGroup, deletePrivateCloudSecurityGroup,
  changePrivateCloudSecurityGroup } from '@/api/private-cloud/security-group'
import moment from 'moment'

export default {
  components: {
    moment
  },
  data () {
    return {
      tableLoading: false,
      securityGroup: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '名称',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            key: 'name'
          },
          {
            title: '安全组ID',
            align: 'center',
            minWidth: 300,
            tooltip: true,
            key: 'id'
          },
          {
            title: '描述',
            align: 'center',
            minWidth: 200,
            tooltip: true,
            key: 'description'
          },
          {
            title: '创建时间',
            align: 'center',
            minWidth: 200,
            key: 'created_at',
            render: (h, params) => {
              return h('span', params.row.created_at ? moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss') : '')
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 220,
            render: (h, params) => {
              let btn = [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({ name: 'security_group_rule', params: { id: params.row.id }, query: { name: params.row.name } })
                    }
                  }
                }, '管理规则')
              ]
              if (params.row.name !== 'default') {
                btn.push(h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.modifyOpen(params.row)
                    }
                  }
                }, '编辑'))
                btn.push(h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ]))
              }
              return h('div', btn)
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      changeModalTitle: '创建安全组',
      changeModal: false,
      changeLoading: false,
      changeForm: {
        id: '',
        name: '',
        description: ''
      },
      changeRule: {
        name: [
          { required: true, message: '安全组名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    this.getSecurityGroupData()
  },
  methods: {
    // 获取安全组列表数据
    getSecurityGroupData (value = 1) {
      this.securityGroup.page = value
      let params = {
        page: this.securityGroup.page,
        size: this.securityGroup.size
      }
      this.tableLoading = true
      getPrivateCloudSecurityGroup(params).then(res => {
        this.securityGroup.data = res.data.results
        this.securityGroup.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取安全组列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取安全组列表失败！服务器无响应'
          })
        }
      })
    },
    // 删除安全组
    delete (row) {
      deletePrivateCloudSecurityGroup(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getSecurityGroupData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 表单重置
    formReset () {
      this.changeForm = {
        id: '',
        name: '',
        description: ''
      }
    },
    // 打开修改表单
    modifyOpen (row) {
      this.formReset()
      this.changeForm.id = row.id
      this.changeForm.name = row.name
      this.changeForm.description = row.description
      this.changeModalTitle = '[' + row.name + '] 编辑'
      this.changeModal = true
    },
    // 提交安全组编辑表单
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          changePrivateCloudSecurityGroup(this.changeForm, this.changeForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getSecurityGroupData()
            this.formReset()
            this.changeLoading = false
            this.changeModal = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
